import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  margin-top: 4px;
  padding: 20px 0px 24px 0px;
  background: #ffffff;
  border-radius: 10px;
  min-height: 550px;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
  padding-left: 20px;
  padding-bottom: 4px;
`;

export const StatusBadge = styled.span`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
  min-width: 48px;
  text-align: center;

  &.status-overdue {
    background-color: #e23d2840;
    color: #e23d28;
  }

  &.status-due {
    background-color: #c8e6c9;
    color: #16851d;
  }

  &.status-due-soon {
    background-color: #fff3cd;
    color: #b7791f;
  }

  &.status-completed {
    background-color: #dbeafe;
    color: #1d4ed8;
  }

  &.status-upcoming {
    background-color: #e8f0ff;
    color: #2c7be5;
  }

  &.status-default {
    background-color: #eef2f6;
    color: #263446;
  }
`;

export const TableWrapper = styled.div`
  background: #ffffff;
  border-radius: 0px;
  overflow-x: auto;
  width: 100%;

  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 10px;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 900px;
`;

export const StickyHeader = styled.thead`
  background: #f1f5f8;
  position: sticky;
  top: 0;
  z-index: 2;
`;

export const HeaderCell = styled.th`
  color: #2c7be5;
  padding: 14px 14px;
  text-align: left;
`;

export const BodyCell = styled.td`
  padding: 16px 24px;
  text-align: ${(props) => props.textAlign || "left"};
`;

export const CellText = styled.div`
  font-family: "manrope", sans-serif;
  font-size: 14px;
  line-height: 19.12px;
  font-weight: 500;
  color: #263446;
  padding-top: 0px;
  overflow-wrap: break-word;
  white-space: unset;
`;
